export { ProductPage } from './ProductPage';
export type { ProductPageProps } from './ProductPage';
